import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowEdgeCommands } from '../constant';
import { Disposable } from '../../common/disposable';
export var NsFrontEdge;
(function (NsFrontEdge) {
    NsFrontEdge.command = XFlowEdgeCommands.FRONT_EDGE;
    NsFrontEdge.hookKey = 'frontEdge';
})(NsFrontEdge || (NsFrontEdge = {}));
let FrontEdgeCommand = 
/** 边前置命令(始终在画布最前方) */
class FrontEdgeCommand {
    constructor() {
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const result = yield hooks.frontEdge.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const x6Graph = yield this.ctx.getX6Graph();
                const { edgeId } = handlerArgs;
                const x6Edge = x6Graph === null || x6Graph === void 0 ? void 0 : x6Graph.getCellById(edgeId);
                if (!x6Edge) {
                    console.error(edgeId, 'this edgeId is not exist');
                }
                else {
                    x6Edge.toFront();
                    /** frontEdge undo */
                    this.ctx.addUndo(Disposable.create(() => __awaiter(this, void 0, void 0, function* () {
                        handlerArgs.commandService.executeCommand(XFlowEdgeCommands.BACK_EDGE.id, {
                            edgeId,
                        });
                    })));
                }
                return {};
            }), runtimeHook);
            this.ctx.setResult(result);
            return this;
        });
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], FrontEdgeCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FrontEdgeCommand.prototype, "init", null);
FrontEdgeCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsFrontEdge.command.id },
    })
    /** 边前置命令(始终在画布最前方) */
], FrontEdgeCommand);
export { FrontEdgeCommand };
//# sourceMappingURL=edge-front.js.map